<template>
  <cf-select-input
    :name="name"
    :label="label"
    :model-value="modelValue"
    :values="options"
    :validations="validations"
    :filterable="true"
    @update:model-value="selectHandler"
  />
</template>


<script>
  import { getCountryOptions } from '@/helpers/address-format';

  import CfSelectInput from '@/view/components/shared/cf-select-input/index.vue';


  export default {
    name: 'CfCountrySelect',

    components: {
      CfSelectInput
    },

    props: {
      /*
        BCP 47 tag used for both country-name localization and alphabetical
        sort order. Defaults to en-US (the app is English-only for now).
      */
      locale: {
        type: String,
        default: 'en-US'
      },

      /*
        ISO 3166-1 alpha-2 country code. Emits `update:modelValue` with the
        same shape on change.
      */
      modelValue: {
        type: String,
        default: null
      },

      name: {
        type: String,
        default: 'country'
      },

      label: {
        type: String,
        default: 'Country'
      },

      /*
        Allowlist of ISO codes the dropdown should expose. Omit (or pass an
        empty array) to show every country in the address metadata — that's
        the credit-card-entry case. For delivery/registration, pass the
        merchant's supported countries.
      */
      countries: {
        type: Array,
        default: null
      },

      validations: {
        type: Object,
        default() {
          return {};
        }
      }
    },

    emits: ['update:modelValue'],

    computed: {
      options() {
        return getCountryOptions({
          countries: this.countries || undefined,
          locale: this.locale
        }).map(({ code, name }) => ({ value: code, display: name }));
      }
    },

    methods: {
      selectHandler(value) {
        this.$emit('update:modelValue', value);
      }
    }
  };
</script>
